/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var I;!function(I){I[I.ANIMATING=0]="ANIMATING",I[I.INTERACTING=1]="INTERACTING",I[I.IDLE=2]="IDLE"}(I||(I={}));export{I as RenderState};
